<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'mainApp',
  components: {
  },
  data() {
    return {

    }
  },
  watch: {

  },
  mounted() {

  },
  computed: {

  },
  props: {

  },
  methods: {

  }
}
</script>

<style scoped>
#app {

}
</style>

<style>
:root{
  --chapter-title-bg: rgba(0, 0, 0, 1);
  --story-bg: rgba(0, 0, 0, .75);
  --gradient-height: 20vh;
}

::-webkit-scrollbar {
  width: 5px;
}
::-webkit-scrollbar-track {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  margin:80px 0 5px 0;
}
::-webkit-scrollbar-thumb {
  -webkit-border-radius: 4px;
  border-radius: 4px;
  background: rgb(219,219,219);
}
</style>
